module.exports = __webpack_public_path__ + "img/img-avatar05.34ef7203.jpg";